// Data locale in formato 'YYYY-MM-DD'.
// Non usare toISOString(): converte in UTC e, in Italia, tra mezzanotte e le
// 2 (o per una data creata a mezzanotte locale) restituisce il giorno prima.
export function localDateStr(d = new Date()) {
	const pad = n => String(n).padStart(2, '0')
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

const pad2 = n => String(n).padStart(2, '0')

function dayLabel(d) {
	return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

function timeLabel(d) {
	return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`
}

function isMidnight(d) {
	return d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0
}

// Assenza a giornate intere: inizio alle 00:00 locali e fine alle 23:59
// (con o senza secondi) oppure alle 00:00 di un giorno successivo (dati
// storici). Le date arrivano dal backend come stringhe ISO.
export function isFullDayAbsence(start, end) {
	if (!start || !end) return false
	const s = new Date(start)
	const e = new Date(end)
	if (isNaN(s) || isNaN(e) || !isMidnight(s)) return false
	if (e.getHours() === 23 && e.getMinutes() === 59) return true
	return isMidnight(e) && e > s
}

// Periodo di un'assenza in forma leggibile:
// '21/09/2026 → 23/09/2026' (giornate intere, una sola data se coincidono),
// '23/09/2026 (mezza giornata)', '23/09/2026 12:30 → 14:30' (a ore).
export function formatAbsenceRange(start, end, halfDay) {
	if (!start || !end) return '-'
	const s = new Date(start)
	const e = new Date(end)
	if (isNaN(s) || isNaN(e)) return '-'

	if (halfDay || isFullDayAbsence(start, end)) {
		// Fine alle 00:00 di un giorno successivo: l'ultimo giorno e' il precedente
		const last = new Date(e)
		if (isMidnight(last) && last > s) last.setDate(last.getDate() - 1)
		const first = dayLabel(s)
		const range = dayLabel(last) === first ? first : `${first} → ${dayLabel(last)}`
		return halfDay ? `${range} (mezza giornata)` : range
	}

	if (localDateStr(s) === localDateStr(e)) {
		return `${dayLabel(s)} ${timeLabel(s)} → ${timeLabel(e)}`
	}
	return `${dayLabel(s)} ${timeLabel(s)} → ${dayLabel(e)} ${timeLabel(e)}`
}
